import { useQuery } from "@tanstack/react-query";
import { getActiveIntegrations } from "../../api/bIntegrationsApi";

export const useGetActiveIntegrations = (organisationId) => {
  return useQuery({
    queryKey: ["active-integrations", organisationId],
    queryFn: () => getActiveIntegrations(organisationId),
    enabled: !!organisationId,
  });
};